import { createRecipe } from './runtime.mjs';

const scrollFadeConfig = {"name":"scrollFade","className":"ds-scroll-fade","defaultVariants":{"axis":"horizontal","size":"md"},"variantMap":{"axis":["horizontal","vertical"],"size":["sm","md","lg"]}}

export const scrollFade = /* @__PURE__ */ createRecipe(scrollFadeConfig)